var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError } from '@wix/metro-runtime/velo';
import * as ambassadorWixEventsV1Order from '@wix/ambassador-events-v1-order/http';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var SubdivisionType;
(function (SubdivisionType) {
    SubdivisionType["UNKNOWN_SUBDIVISION_TYPE"] = "UNKNOWN_SUBDIVISION_TYPE";
    /** State */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_1"] = "ADMINISTRATIVE_AREA_LEVEL_1";
    /** County */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_2"] = "ADMINISTRATIVE_AREA_LEVEL_2";
    /** City/town */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_3"] = "ADMINISTRATIVE_AREA_LEVEL_3";
    /** Neighborhood/quarter */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_4"] = "ADMINISTRATIVE_AREA_LEVEL_4";
    /** Street/block */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_5"] = "ADMINISTRATIVE_AREA_LEVEL_5";
    /** ADMINISTRATIVE_AREA_LEVEL_0. Indicates the national political entity, and is typically the highest order type returned by the Geocoder. */
    SubdivisionType["COUNTRY"] = "COUNTRY";
})(SubdivisionType || (SubdivisionType = {}));
export var OrderStatus;
(function (OrderStatus) {
    /** Order status not available for this request fieldset */
    OrderStatus["NA_ORDER_STATUS"] = "NA_ORDER_STATUS";
    /** Order is confirmed, no payment required */
    OrderStatus["FREE"] = "FREE";
    /** Order was paid but payment gateway suspended the payment. Eventually changes to PAID */
    OrderStatus["PENDING"] = "PENDING";
    /** Order paid via payment gateway */
    OrderStatus["PAID"] = "PAID";
    /** Order confirmed but has to be paid via offline payment and status manually updated to PAID */
    OrderStatus["OFFLINE_PENDING"] = "OFFLINE_PENDING";
    /** Order is awaiting for payment in Cashier */
    OrderStatus["INITIATED"] = "INITIATED";
    /** Order was canceled */
    OrderStatus["CANCELED"] = "CANCELED";
    /** Order payment was declined */
    OrderStatus["DECLINED"] = "DECLINED";
})(OrderStatus || (OrderStatus = {}));
export var ChannelType;
(function (ChannelType) {
    /** Buyer created order via one of the online channels (website, mobile app, etc.) */
    ChannelType["ONLINE"] = "ONLINE";
    /** Order created and money collected by the sales person */
    ChannelType["OFFLINE_POS"] = "OFFLINE_POS";
})(ChannelType || (ChannelType = {}));
export var TaxType;
(function (TaxType) {
    /** Tax is included in the ticket price */
    TaxType["INCLUDED"] = "INCLUDED";
    /** Tax is added to the order at the checkout */
    TaxType["ADDED"] = "ADDED";
    /** Tax is added to the final total at the checkout */
    TaxType["ADDED_AT_CHECKOUT"] = "ADDED_AT_CHECKOUT";
})(TaxType || (TaxType = {}));
export var FeeName;
(function (FeeName) {
    /** Wix service fee charges applied to the line item. */
    FeeName["WIX_FEE"] = "WIX_FEE";
})(FeeName || (FeeName = {}));
export var FeeType;
(function (FeeType) {
    /** Fee is added to the ticket price at checkout */
    FeeType["FEE_ADDED"] = "FEE_ADDED";
    /** Seller absorbs the fee. It is deducted from the ticket price */
    FeeType["FEE_INCLUDED"] = "FEE_INCLUDED";
    /** Fee is added to the ticket price at checkout */
    FeeType["FEE_ADDED_AT_CHECKOUT"] = "FEE_ADDED_AT_CHECKOUT";
})(FeeType || (FeeType = {}));
export var OrderType;
(function (OrderType) {
    /** Buyer form is used for all tickets */
    OrderType["UNASSIGNED_TICKETS"] = "UNASSIGNED_TICKETS";
    /** Each order ticket has its own form */
    OrderType["ASSIGNED_TICKETS"] = "ASSIGNED_TICKETS";
})(OrderType || (OrderType = {}));
export var OrderFieldset;
(function (OrderFieldset) {
    /** Include tickets in response */
    OrderFieldset["TICKETS"] = "TICKETS";
    /** Include order details: status, first_name, last_name, email, created, etc. */
    OrderFieldset["DETAILS"] = "DETAILS";
    /** Include checkout_form */
    OrderFieldset["FORM"] = "FORM";
    /** Include invoice */
    OrderFieldset["INVOICE"] = "INVOICE";
})(OrderFieldset || (OrderFieldset = {}));
export var OrderTag;
(function (OrderTag) {
    /** Return only confirmed orders */
    OrderTag["CONFIRMED"] = "CONFIRMED";
    /** Return only unconfirmed orders */
    OrderTag["UNCONFIRMED"] = "UNCONFIRMED";
    /** Return only member orders */
    OrderTag["MEMBER"] = "MEMBER";
    /** Return only archived orders */
    OrderTag["ARCHIVED"] = "ARCHIVED";
    /** Return only non archived orders */
    OrderTag["NON_ARCHIVED"] = "NON_ARCHIVED";
    /** Return only orders with all guests checked-in */
    OrderTag["FULLY_CHECKED_IN"] = "FULLY_CHECKED_IN";
    /** Return only orders with no guests checked-in */
    OrderTag["NOT_FULLY_CHECKED_IN"] = "NOT_FULLY_CHECKED_IN";
})(OrderTag || (OrderTag = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
export var ReservationStatus;
(function (ReservationStatus) {
    /**
     * Reservation is pending confirmation.
     * The reservation will expire after the expiration due time.
     */
    ReservationStatus["RESERVATION_PENDING"] = "RESERVATION_PENDING";
    /** The reservation was confirmed and will not expire. */
    ReservationStatus["RESERVATION_CONFIRMED"] = "RESERVATION_CONFIRMED";
    /** The reservation was canceled because of non payment. */
    ReservationStatus["RESERVATION_CANCELED"] = "RESERVATION_CANCELED";
    /** The reservation was canceled manually by the buyer. */
    ReservationStatus["RESERVATION_CANCELED_MANUALLY"] = "RESERVATION_CANCELED_MANUALLY";
    /** The reservation has expired. */
    ReservationStatus["RESERVATION_EXPIRED"] = "RESERVATION_EXPIRED";
})(ReservationStatus || (ReservationStatus = {}));
export var State;
(function (State) {
    State["INCLUDE_HIDDEN_NOT_ON_SALE"] = "INCLUDE_HIDDEN_NOT_ON_SALE";
})(State || (State = {}));
export var TicketSaleStatus;
(function (TicketSaleStatus) {
    /** Ticket sale is scheduled to start */
    TicketSaleStatus["SALE_SCHEDULED"] = "SALE_SCHEDULED";
    /** Ticket sale has started */
    TicketSaleStatus["SALE_STARTED"] = "SALE_STARTED";
    /** Ticket sale has ended */
    TicketSaleStatus["SALE_ENDED"] = "SALE_ENDED";
})(TicketSaleStatus || (TicketSaleStatus = {}));
export var Type;
(function (Type) {
    Type["STANDARD"] = "STANDARD";
    Type["DONATION"] = "DONATION";
})(Type || (Type = {}));
export var TicketDefinitionFieldset;
(function (TicketDefinitionFieldset) {
    /** Include policy in the response. */
    TicketDefinitionFieldset["POLICY"] = "POLICY";
    /** Include dashboard in the response. */
    TicketDefinitionFieldset["DASHBOARD"] = "DASHBOARD";
})(TicketDefinitionFieldset || (TicketDefinitionFieldset = {}));
const _bulkUpdateOrdersRequest = {};
const _bulkUpdateOrdersResponse = { orders: '_order' };
const _cancelReservationRequest = {};
const _cancelReservationResponse = {};
const _checkoutRequest = { guests: '_guest' };
const _checkoutResponse = { order: '_order' };
const _confirmOrderRequest = {};
const _confirmOrderResponse = { orders: '_order' };
const _createReservationRequest = {};
const _createReservationResponse = {};
const _formattedAddress = { address: 'wix.common.Address' };
const _formResponse = { inputValues: '_inputValue' };
const _getCheckoutOptionsRequest = {};
const _getCheckoutOptionsResponse = {};
const _getInvoicePreviewRequest = {};
const _getInvoiceRequest = {};
const _getInvoiceResponse = {};
const _getOrderRequest = {};
const _getOrderResponse = { order: '_order' };
const _getSummaryRequest = {};
const _getSummaryResponse = {};
const _guest = { form: '_formResponse' };
const _guestDetails = { form: '_formResponse' };
const _inputValue = { address: '_formattedAddress' };
const _listAvailableTicketsRequest = {};
const _listAvailableTicketsResponse = {};
const _listOrdersRequest = {};
const _listOrdersResponse = { orders: '_order' };
const _order = { checkoutForm: '_formResponse', tickets: '_ticketingTicket' };
const _posCheckoutRequest = {};
const _posCheckoutResponse = { order: '_order' };
const _queryAvailableTicketsRequest = {};
const _queryAvailableTicketsResponse = {};
const _rawHttpResponse = {};
const _ticketingTicket = { guestDetails: '_guestDetails' };
const _updateCheckoutRequest = { guests: '_guest' };
const _updateCheckoutResponse = { order: '_order' };
const _updateOrderRequest = { checkoutForm: '_formResponse' };
const _updateOrderResponse = { order: '_order' };
/**
 * Retrieves a list of orders, including ticket data.
 * @public
 * @param options - An object representing the available options for retrieving a list of orders.
 * @adminMethod
 */
export function listOrders(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            offset: '$[0].offset',
            limit: '$[0].limit',
            fieldset: '$[0].fieldset',
            status: '$[0].status',
            confirmed: '$[0].confirmed',
            eventId: '$[0].eventId',
            orderNumber: '$[0].orderNumber',
            memberId: '$[0].memberId',
            membersOnly: '$[0].membersOnly',
            facet: '$[0].facet',
            archived: '$[0].archived',
            searchPhrase: '$[0].searchPhrase',
            eventCreatorId: '$[0].eventCreatorId',
            fullyCheckedIn: '$[0].fullyCheckedIn',
            sort: '$[0].sort',
            tag: '$[0].tag',
            contactId: '$[0].contactId',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _listOrdersRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _listOrdersResponse,
            depSchemas: {
                _formResponse,
                _formattedAddress,
                _guestDetails,
                _inputValue,
                _order,
                _ticketingTicket,
            },
            fqdnTransformation: {
                paths: [...['Array#orders']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixEventsV1Order.listOrders(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves an order, including ticket data.
 * <!--
 * >The fieldsets in this function are restricted and only run if you elevate permissions using the [wix-auth.elevate()](https://www.wix.com/velo/reference/wix-auth/elevate) function.
 * -->
 * @public
 * @requiredField identifiers
 * @requiredField identifiers.eventId
 * @requiredField identifiers.orderNumber
 * @param options - An object representing the available options for getting an order.
 * @param identifiers - An object containing identifiers for the order to be retrieved.
 * @adminMethod
 * @returns Requested order.
 */
export function getOrder(identifiers, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            eventId: '$[0].eventId',
            orderNumber: '$[0].orderNumber',
            fieldset: '$[1].fieldset',
        };
        const responseTransformation = '$.order';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getOrderRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getOrderResponse,
            depSchemas: {
                _formResponse,
                _formattedAddress,
                _guestDetails,
                _inputValue,
                _order,
                _ticketingTicket,
            },
            fqdnTransformation: {
                paths: [...['order']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([identifiers, options]);
        const reqOpts = ambassadorWixEventsV1Order.getOrder(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'identifiers',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Updates an order.
 * @public
 * @requiredField identifiers
 * @requiredField identifiers.eventId
 * @requiredField identifiers.orderNumber
 * @param options - An object representing the available options for updating an order.
 * @param identifiers - An object containing identifiers for the order to be updated.
 * @adminMethod
 */
export function updateOrder(identifiers, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            eventId: '$[0].eventId',
            orderNumber: '$[0].orderNumber',
            fields: '$[1].fields',
            checkoutForm: '$[1].checkoutForm',
            archived: '$[1].archived',
            expires: '$[1].expires',
            silent: '$[1].silent',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _updateOrderRequest,
            depSchemas: { _formResponse, _formattedAddress, _inputValue },
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _updateOrderResponse,
            depSchemas: {
                _formResponse,
                _formattedAddress,
                _guestDetails,
                _inputValue,
                _order,
                _ticketingTicket,
            },
            fqdnTransformation: {
                paths: [...['order']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([identifiers, options]);
        const reqOpts = ambassadorWixEventsV1Order.updateOrder(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'identifiers',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Archives multiple orders.
 * @public
 * @requiredField eventId
 * @param options - An object representing the available options for confirming an order.
 * @param eventId - Event ID to which the order belongs.
 * @adminMethod
 */
export function bulkUpdateOrders(eventId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            eventId: '$[0]',
            orderNumber: '$[1].orderNumber',
            fields: '$[1].fields',
            archived: '$[1].archived',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _bulkUpdateOrdersRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _bulkUpdateOrdersResponse,
            depSchemas: {
                _formResponse,
                _formattedAddress,
                _guestDetails,
                _inputValue,
                _order,
                _ticketingTicket,
            },
            fqdnTransformation: {
                paths: [...['Array#orders']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([eventId, options]);
        const reqOpts = ambassadorWixEventsV1Order.bulkUpdateOrders(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'eventId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Confirms an order.
 *
 *
 * This function changes order status from `INITIATED`, `PENDING`, `OFFLINE_PENDING` to `PAID`.
 * Confirming orders with `INITIATED` or `PENDING` status triggers an email with the tickets to the buyer (and to additional guests, if provided).
 * @public
 * @requiredField eventId
 * @param options - An object representing the available options for confirming an order.
 * @param eventId - Event ID to which the order belongs.
 * @adminMethod
 */
export function confirmOrder(eventId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            eventId: '$[0]',
            orderNumber: '$[1].orderNumber',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _confirmOrderRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _confirmOrderResponse,
            depSchemas: {
                _formResponse,
                _formattedAddress,
                _guestDetails,
                _inputValue,
                _order,
                _ticketingTicket,
            },
            fqdnTransformation: {
                paths: [...['Array#orders']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([eventId, options]);
        const reqOpts = ambassadorWixEventsV1Order.confirmOrder(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'eventId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves a summary of total ticket sales.
 * <!--
 * > Note: This function is restricted and only runs if you elevate permissions using the [wix-auth.elevate()](https://www.wix.com/velo/reference/wix-auth/elevate) function.
 * -->
 * @public
 * @param options - An object representing the available options for retrieving a summary of total ticket sales.
 * @adminMethod
 */
export function getSummary(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { eventId: '$[0].eventId' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getSummaryRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getSummaryResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixEventsV1Order.getSummary(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Returns invoice preview. Works only for PAID orders.
 * @internal
 * @requiredField identifiers
 * @requiredField identifiers.eventId
 * @requiredField identifiers.orderNumber
 * @adminMethod
 */
export function getInvoicePreview(identifiers) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            eventId: '$[0].eventId',
            orderNumber: '$[0].orderNumber',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getInvoicePreviewRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _rawHttpResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([identifiers]);
        const reqOpts = ambassadorWixEventsV1Order.getInvoicePreview(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'identifiers',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves checkout details.
 * @public */
export function getCheckoutOptions() {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {};
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[0];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getCheckoutOptionsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getCheckoutOptionsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([]);
        const reqOpts = ambassadorWixEventsV1Order.getCheckoutOptions(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, []);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Returns tickets available to reserve.
 * <!--
 * > Note: This function is restricted and only runs if you elevate permissions using the [wix-auth.elevate()](https://www.wix.com/velo/reference/wix-auth/elevate) function.
 * -->
 * @public
 * @param options - An object representing the available options for retrieving a list of tickets available for reservation.
 */
export function listAvailableTickets(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            eventId: '$[0].eventId',
            offset: '$[0].offset',
            limit: '$[0].limit',
            sort: '$[0].sort',
            overrideRequestTime: '$[0].overrideRequestTime',
            state: '$[0].state',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _listAvailableTicketsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _listAvailableTicketsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixEventsV1Order.listAvailableTickets(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Returns tickets available to reserve.
 * <!--
 * > Note: The fieldsets in this function are restricted and only run if you elevate permissions using the [wix-auth.elevate()](https://www.wix.com/velo/reference/wix-auth/elevate) function.
 * -->
 * @public
 * @param options - An object representing the available options for retrieving a list of tickets available for reservation.
 */
export function queryAvailableTickets(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            offset: '$[0].offset',
            limit: '$[0].limit',
            filter: '$[0].filter',
            fieldset: '$[0].fieldset',
            sort: '$[0].sort',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _queryAvailableTicketsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _queryAvailableTicketsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixEventsV1Order.queryAvailableTickets(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Reserves tickets for 20 minutes.
 *
 *
 * Reserved tickets are deducted from ticket stock and cannot be bought by another site visitor.
 * When the reservation expires, the tickets are added back to the stock.
 * @public
 * @requiredField eventId
 * @param options - An object representing the available options for creating a reservation.
 * @param eventId - Event ID to which the reservation belongs.
 */
export function createReservation(eventId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            eventId: '$[0]',
            ticketQuantities: '$[1].ticketQuantities',
            ignoreLimits: '$[1].ignoreLimits',
            overrideRequestTime: '$[1].overrideRequestTime',
            allowHiddenTickets: '$[1].allowHiddenTickets',
            excludeFee: '$[1].excludeFee',
            skipPriceOverrideValidation: '$[1].skipPriceOverrideValidation',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _createReservationRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _createReservationResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([eventId, options]);
        const reqOpts = ambassadorWixEventsV1Order.createReservation(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'eventId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Cancels ticket reservation and returns tickets to stock.
 * <!--
 * > Note: This function is restricted and only runs if you elevate permissions using the [wix-auth.elevate()](https://www.wix.com/velo/reference/wix-auth/elevate) function.
 * -->
 * @param _id - Reservation ID.
 * @public
 * @requiredField _id
 * @requiredField eventId
 * @param identifiers - An object containing identifiers for the reservation to be cancelled.
 * @param eventId - Event ID to which the reservation belongs.
 */
export function cancelReservation(_id, eventId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { id: '$[0]', eventId: '$[1]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _cancelReservationRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _cancelReservationResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id, eventId]);
        const reqOpts = ambassadorWixEventsV1Order.cancelReservation(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
                'eventId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Generates a preview of an invoice, including the given coupon or pricing plan.
 * @param reservationId - Reservation ID.
 * @public
 * @requiredField eventId
 * @requiredField reservationId
 * @param options - An object representing the available options for generating a preview of a reservation invoice.
 * @param identifiers - An object containing identifiers for the reservation invoice preview to be generated.
 * @param eventId - Event ID to which the invoice belongs.
 */
export function getInvoice(reservationId, eventId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            reservationId: '$[0]',
            eventId: '$[1]',
            withDiscount: '$[2].withDiscount',
            paidPlanBenefit: '$[2].paidPlanBenefit',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[3];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getInvoiceRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getInvoiceResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([reservationId, eventId, options]);
        const reqOpts = ambassadorWixEventsV1Order.getInvoice(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'reservationId',
                'eventId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Checkouts the reserved tickets.
 *
 *
 * Creates an order and associates it with a site visitor contact.
 * Guest details are received from the [Registration Form](https://www.wix.com/velo/reference/wix-events-v2/forms/introduction) input fields.
 *
 * There is a possibility to use a separate ready-made Wix checkout form where the user will be redirected from your non-Wix site or a custom ticket picker created with Velo.
 * To build the checkout form path, get your event base URL by using the [`getEvent()`](https://www.wix.com/velo/reference/wix-events-backend/wixevents/getevent) function and add the following path:
 * `/{{EVENT_PAGE_SLUG}}/{{SLUG}}/ticket-form?reservationId={{YOUR_RESERVATION_ID}}`
 *
 * Example:  `https://johndoe.wixsite.com/weddings/event-details/doe-wedding/ticket-form?reservationId=2be6d34a-2a1e-459f-897b-b4a66e73f69a`
 * @public
 * @requiredField eventId
 * @requiredField options.guests.form
 * @param options - An object representing the available options for checking out a reserved ticket.
 * @param eventId - Event ID to which the checkout belongs.
 */
export function checkout(eventId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            eventId: '$[0]',
            reservationId: '$[1].reservationId',
            memberId: '$[1].memberId',
            discount: '$[1].discount',
            silent: '$[1].silent',
            payInPerson: '$[1].payInPerson',
            buyer: '$[1].buyer',
            guests: '$[1].guests',
            paidPlanBenefit: '$[1].paidPlanBenefit',
            options: '$[1].options',
            overrideRequestTime: '$[1].overrideRequestTime',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _checkoutRequest,
            depSchemas: { _formResponse, _formattedAddress, _guest, _inputValue },
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _checkoutResponse,
            depSchemas: {
                _formResponse,
                _formattedAddress,
                _guestDetails,
                _inputValue,
                _order,
                _ticketingTicket,
            },
            fqdnTransformation: {
                paths: [...['order']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([eventId, options]);
        const reqOpts = ambassadorWixEventsV1Order.checkout(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'eventId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Updates order and tickets.
 *
 *
 * Only applicable for orders with `INITIATED`, `PENDING`, `OFFLINE_PENDING` statuses.
 * @param orderNumber - Unique order number.
 * @public
 * @requiredField eventId
 * @requiredField orderNumber
 * @param options - An object representing the available options for updating an order and tickets.
 * @param identifiers - An object containing identifiers for the order and tickets to be updated.
 * @param eventId - Event ID to which the checkout belongs.
 */
export function updateCheckout(orderNumber, eventId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            orderNumber: '$[0]',
            eventId: '$[1]',
            buyer: '$[2].buyer',
            guests: '$[2].guests',
            memberId: '$[2].memberId',
            discount: '$[2].discount',
            paidPlanBenefit: '$[2].paidPlanBenefit',
            paymentDetailsId: '$[2].paymentDetailsId',
            paymentMethod: '$[2].paymentMethod',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[3];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _updateCheckoutRequest,
            depSchemas: { _formResponse, _formattedAddress, _guest, _inputValue },
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _updateCheckoutResponse,
            depSchemas: {
                _formResponse,
                _formattedAddress,
                _guestDetails,
                _inputValue,
                _order,
                _ticketingTicket,
            },
            fqdnTransformation: {
                paths: [...['order']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([orderNumber, eventId, options]);
        const reqOpts = ambassadorWixEventsV1Order.updateCheckout(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'orderNumber',
                'eventId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Creates order with payment details already initiated via Cashier Pay API.
 * @public
 * @requiredField eventId
 * @requiredField options.reservationId
 * @param eventId - Event ID to which the checkout belongs.
 * @adminMethod
 */
export function posCheckout(eventId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            eventId: '$[0]',
            reservationId: '$[1].reservationId',
            paymentDetailsId: '$[1].paymentDetailsId',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _posCheckoutRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _posCheckoutResponse,
            depSchemas: {
                _formResponse,
                _formattedAddress,
                _guestDetails,
                _inputValue,
                _order,
                _ticketingTicket,
            },
            fqdnTransformation: {
                paths: [...['order']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([eventId, options]);
        const reqOpts = ambassadorWixEventsV1Order.posCheckout(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'eventId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=events-v1-order.universal.js.map